import TipsDetails from './TipsDetails'

export default TipsDetails
